import { useState, useEffect } from "react";
import useQueryParams from "../../hooks/useQueryParams";
import Label from "../../components/form/Label";
import ButtonIconOnly from "../../components/ui/button/ButtonIconOnly";

const CategoryTableFilter = ({ categorySearch, onSearch, onReset }) => {
  const { updateQueryParam, queryParams } = useQueryParams();
  const [searchValue, setSearchValue] = useState(queryParams.get("categorySearch") || "");

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      updateQueryParam("page", 0);
      updateQueryParam("categorySearch", searchValue);
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchValue]);

  const resetFilters = () => {
    setSearchValue("");
    updateQueryParam("categorySearch", "");
    // updateQueryParam("page", 0);
    // updateQueryParam("size", DEFAULT_PER_PAGE);
  };

  return (
    <div className="flex flex-col md:flex-row md:items-end gap-3">
      <div className="flex flex-col w-full md:w-64">
        <Label variant="filter" title="Name" />
        <input
          className="search-button-input-hover"
          type="text"
          value={categorySearch}
          placeholder="Search Category"
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>

      <div className="flex flex-col md:ml-auto">
        <Label variant="filter" title="&nbsp;" className="hidden md:block" />
        <div className="flex items-center gap-6">
          <ButtonIconOnly
            title="Reset"
            // className="search-button"
            onClick={onReset}
            icon={
              <svg className="w-5 h-5" viewBox="0 0 512 512" fill="currentColor">
                <path d="M64,256H34A222,222,0,0,1,430,118.15V85h30V190H355V160h67.27A192.21,192.21,0,0,0,256,64C150.13,64,64,150.13,64,256Zm384,0c0,105.87-86.13,192-192,192A192.21,192.21,0,0,1,89.73,352H157V322H52V427H82V393.85A222,222,0,0,0,478,256Z" />
              </svg>
            }
          />
        </div>
      </div>
    </div>
  );

  // return (
  //   <div className="flex flex-col md:flex-row md:items-end gap-3">
  //     <div className="flex flex-col w-full md:w-64">
  //       <Label variant="filter" title="Name" />
  //       <input
  //         className="primary px-3 py-2 rounded-lg border border-gray-300 focus:border-brand-500 focus:ring focus:ring-brand-200 outline-none transition text-sm"
  //         type="text"
  //         value={searchValue}
  //         placeholder="Search Category"
  //         onChange={(e) => setSearchValue(e.target.value)}
  //       />
  //     </div>

  //     <div className="flex items-center gap-6 md:ml-auto">
  //       {/* Reset Button */}
  //       <ButtonIconOnly
  //         title="Reset"
  //         className="p-2 rounded-lg bg-gray-100 hover:bg-gray-200 text-gray-600 transition flex items-center justify-center"
  //         icon={
  //           <svg className="w-5 h-5" viewBox="0 0 512 512" fill="currentColor">
  //             <path d="M64,256H34A222,222,0,0,1,430,118.15V85h30V190H355V160h67.27A192.21,192.21,0,0,0,256,64C150.13,64,64,150.13,64,256Zm384,0c0,105.87-86.13,192-192,192A192.21,192.21,0,0,1,89.73,352H157V322H52V427H82V393.85A222,222,0,0,0,478,256Z" />
  //           </svg>
  //         }
  //         onClick={resetFilters}
  //       />
  //     </div>
  //   </div>
  // );
};
export default CategoryTableFilter;
